document.addEventListener('DOMContentLoaded', function (e) {
	let return_buttons = document.querySelectorAll('.a-button--return');
	let scroll_time;
	if (return_buttons.length > 0) {
		return_buttons.forEach((return_button) => {
			return_button.addEventListener('click', function (e) {
				if (scroll_time) {
					window.clearTimeout(scroll_time);
				}

				window.scroll(0, 0);

				let subnav = document.querySelector('#subnav');
				if (subnav) {
					scroll_time = window.setTimeout(() => {
						if (window.scrollX <= 0) {
							let active = subnav.querySelector('.active');
							active.classList.remove('active');
						}
					}, 250);
				}
			});
		});
	}
});
